import { AuthenticatedLayout } from "../../layouts";
import { FC } from "react";
import { PayrollScheduleSetup } from "../../components/PayrollSchedule";

export interface IPayrollSchedulePage { }

export const PayrollSchedulePage: FC<IPayrollSchedulePage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Payroll Schedule"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[
				{ text: "Payroll Schedule", navigateTo: "" },
			]}
			mainContents={<PayrollScheduleSetup />}
		/>
	);
};
